// extracted by mini-css-extract-plugin
export default {"match":"ComparisonPicker_match__BUpSD"};